export enum RegisterStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  LOADING = 'loading',
}

export enum AppStyles {
  TOAST_PRIMARY = 'bg-sivarbet-primary border-0 text-white',
  TOAST_SECONDARY = 'bg-sivarbet-secondary border-0 text-white',
  TOAST_DANGER = 'bg-red-600 border-0 text-white',
}

export enum Vendors {
  GOOGLE = 1,
  EMAIL = 2,
  PHONE = 3,
}

export enum TransactionTypes {
  RECHARGE = 1,
  DEPOSIT = 2,
  WITHDRAWL = 3,
  ADJUST_DEP = 4,
  ADJUST_DISP = 5,
  RECHARGE_DISP = 6,
  COMMISSION = 7,
}

export enum Currency {
  GTQ = 1,
  USD = 2,
  DOP = 3,
  HNL = 4,
}

export enum Gateway {
  MANUAL = 1,
  BANK = 2,
  CASH = 3,
  CHIVO = 4,
  COINPAYMENTS = 5,
  PAYPHONE = 6,
  NICO = 7,
  TIGO = 8,
  SOMPOPO = 9,
  GINIH = 10,
  UNLIMIT = 11,
  EUKAPAY = 12,
  GOOGLEPAY = 13,
  APPLEPAY = 14,
  PRAXIS = 15,
  BONUS = 17,
  SOMPOPO_APP = 16,
  PRAXIS_PAYOUT = 18,
  PAYCASH = 19,
  CRYPTO = 20,
  TEN_COINS = 21,
}

export enum CalendarRange {
  TODAY = 0,
  YESTERDAY = 1,
  THREE_DAYS_AGO = 3,
  ONE_WEEK_AGO = 7,
  LAST_30_DAYS = 30,
}

export enum TransactionStates {
  COMPLETE = 1,
  APPROVED = 2,
  ISSUED = 3,
  REJECTED = 4,
  CANCELLED = 5,
  ROLLBACK = 6,
  PENDING = 7,
  FINISHED = 8,
  IN_PROCESS = 9,
}

export enum AuthType {
  SIGNIN = 'signin',
  REGISTER = 'register',
}

export enum WalletType {
  BANK = 1,
  WALLET = 2,
}

export enum WalletMethod {
  WITHDRAW = 1,
  DEPOSIT = 2,
}

export enum WalletCurrency {
  BTC = 1,
  USDT = 2,
  ETH = 3,
  SOL = 4,
  USDC = 5,
}

export enum WalletNetwork {
  DEFAULT = 0,
  AHORROS = 1,
  CORRIENTE = 2,
  CHIVO = 3,
  TRON = 4,
  LTCT = 5,
  BTC = 6,
  ETH = 7,
}

export enum UserKYCStatus {
  DEFAULT = 0,
  PENDING = 1,
  APPROVED = 2,
  REJECTED = 3,
}

export enum UserKYCLevel {
  DEFAULT = 1,
  APPROVED = 2,
  NOT_REQUIRED = 0,
}

export enum ProfileGender {
  DEFAULT = 0,
  MALE = 1,
  FEMALE = 2,
  OTHER = 3,
}

export enum ProfileDocument {
  DNI = 1,
  PASSPORT = 2,
}

export enum BetStatus {
  DEFAULT = '',
  LOST = 'Lost',
  WON = 'Won',
  CASHOUT = 'Cashout',
  VOID = 'Cancelada-Void',
  REJECTED = 'Cancelada-Rejected',
  PENDING = 'Pending',
  CASHOUT_PARCIAL = 'Cashout Parcial',
  OPEN = 'Open',
}

export enum GameResult {
  DEFAULT = 0,
  BET = 1,
  WIN = 2,
  ROLLBACK = 3,
  CREDIT = 4,
}

export enum GameVendor {
  SOFTSWISS = 1,
  KINGMIDAS = 2,
  HUB88 = 3,
}

export enum MovementSource {
  TRANSACTION = 1,
  GAME = 2,
  BET = 3,
}

export enum WithdrawalMethod {
  CASH = 1,
  BANK = 2,
  CRYPTO = 3,
  CREDIT_CARD = 4,
}

export enum TransactionType {
  RECHARGE = 'recarga',
  WITHDRAWAL = 'retiro',
  BET = 'apuesta',
}

export enum ErrorCodes {
  NO_AUTHORIZATION = 1000,
  NO_JWT_TOKEN = 10001,
}

export enum BonusType {
  SPORTS = 'sports',
  CASINO = 'casino',
  PERCENTAGE = 'percentage',
}

export enum BonusStatusSport {
  PENDING = 'Waiting',
  APPLIED = 'Active',
  CLOSED = 'Closed',
  AWARDED = 'Awarded',
  EXPIRED = 'Expired',
  CANCELLED = 'Cancelled',
}

export enum BonusStatusCasino {
  PENDING = 1,
  APPLIED = 2,
  CLOSED = 3,
  EXPIRED = 4,
  ROLLED_BACK = 5,
  CANCELLED = 6,
}

export enum BonusDispatcher {
  REGISTER = 1,
  FIRST_DEPOSIT = 20,
  SECOND_DEPOSIT = 21,
  THIRD_DEPOSIT = 22,
  NEXT_DEPOSIT = 23,
}

export enum BonusTypeAltenar {
  CODE = 'CreateByCode',
  DEPOSIT = 'CreateByDeposit',
}
export enum VoucherBank {
  BANKPAIS = 1,
  BAC = 2,
}

export enum VoucherStatus {
  DEFAULT = 0,
  APPROVED = 1,
  DENIED = 2,
}

export enum BonusCasinoGameType {
  FREESPINS = 'freespin',
}

export enum GatewayType {
  CASH = 'efectivo',
  BANK = 'banco',
}

export enum VoucherTypes {
  REQUESTED = 0,
  APPROVED = 1,
  REJECTED = 2,
  ANNULLED = 3,
  ALL = 100,
}

export enum CashDescriptionType {
  PRAXIS = 'praxis',
  PAYCASH = 'paycash',
}

export enum ReferralStatus {
  PENDING = 1,
  APPROVAL = 2,
  REJECTED = 3,
  COMPLETED = 4,
  EXPIRED = 5,
}

export enum VIPLevel {
  DEFAULT = 'DEFAULT',
  START = 'START',
  BASIC = 'BASIC',
  PRO = 'PRO',
  ELITE = 'ELITE',
  MASTER = 'MASTER',
}

export enum VipBonusType {
  SPORTS = 1,
  CASINO = 2,
  DEPOSIT = 3,
  BIRTHDAY = 4,
}

export enum VipBonusFrequency {
  WEEKLY = 1,
  MONTHLY = 2,
  BIRTHDAY = 3,
}

export enum TournamentTypes {
  SPORT = 'sport',
  CHAMPIONSHIP = 'championship',
  EVENT = 'event',
}

export enum EnabledBetTypes {
  MIXED = 'Mixed',
  LIVE = 'Live',
  PRE_LIVE = 'PreLive',
}

export enum TournamentErrorCodes {
  DEV_BL_001 = 'DEV-BL-001',
}

export enum Hub88ErrorCode {
  INVALID_PARAMETER = 1001,
  PLAYER_NOT_FOUND = 1002,
  INSUFFICIENT_BALANCE = 1003,
  TRANSACTION_NOT_FOUND = 1004,
  DUPLICATE_TRANSACTION = 1005,
  INVALID_SIGNATURE = 1006,
  INTERNAL_ERROR = 9999,
}

export enum Hub88ResponseStatus {
  SUCCESS = 'RS_OK',
  ERROR = 'RS_ERROR',
}

export enum Hub88Platform {
  DESKTOP = 'GPL_DESKTOP',
  MOBILE = 'GPL_MOBILE',
}

export enum WelcomeBonusType {
  SPORTS = 1,
  CASINO = 2,
}

export enum OtpType {
  PASSWORD_CHANGE = 'PASSWORD_CHANGE',
}

export enum OtpMethod {
  EMAIL = 1,
}

export enum KycWebhookEvent {
  VERIFICATION_STARTED = 'verification_started',
  VERIFICATION_SUBMITTED = 'verification_submitted',
  VERIFICATION_COMPLETED = 'verification_completed',
  VERIFICATION_UPDATED = 'verification_updated',
  VERIFICATION_APPROVED = 'verification_approved',
  VERIFICATION_REJECTED = 'verification_rejected',
  VERIFICATION_REVIEW = 'verification_review',
  VERIFICATION_EXPIRED = 'verification_expired',
}

export enum KycEmailStatus {
  STARTED = 'started',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  REVIEW = 'review',
  EXPIRED = 'expired',
  ABANDONED = 'abandoned',
}

export enum KycLogAction {
  USER_STARTED_VERIFICATION = 'Usuario inició verificación',
  USER_ABANDONED_VERIFICATION = 'Usuario abandonó verificación',
  WEBHOOK_RECEIVED = 'Webhook recibido',
  WEBHOOK_PROCESSED = 'Webhook procesado',
  STATE_UPDATED = 'Estado actualizado',
  VERIFICATION_REJECTED = 'Verificación rechazada',
  REJECTION_DETAILS = 'Detalles de rechazo',
  STEPS_ANALYSIS = 'Análisis de steps',
  DETAILS_ANALYSIS = 'Análisis de details',
  SELFIE_ANALYSIS = 'Análisis de selfie',
  DOCUMENT_ANALYSIS = 'Análisis de documento',
  FACE_MATCH_ANALYSIS = 'Análisis de face match',
  FACE_MATCH_SUCCESS = 'Face match exitoso',
  DISCREPANCY_DETECTED = 'DISCREPANCIA DETECTADA',
  REVIEW_REJECTION_STATE = 'Estado de revisión/rechazo',
  REQUEST_SENT = 'Request enviado',
  RESPONSE = 'Respuesta',
  ERROR = 'Error',
  STATE_UPDATED_FROM_API = 'Estado actualizado desde API',
}
